import React from "react"
import type {
    AssinanteClube,
    MensalidadeClube,
    ResumoFinanceiroClube,
    StatusAssinaturaClube,
    TotaisAssinantesClube,
} from "../../../services/clubeBeneficios"
import type { ClubeBeneficiosModel } from "../models/clubeBeneficiosModel"
import { ClubeBeneficiosInicial } from "../models/clubeBeneficiosModel"
import type { ClubeBeneficiosActionModel } from "./clubeBeneficiosActions"

export const TotaisAssinantesInicial: TotaisAssinantesClube = {
    pendentes: 0,
    ativas: 0,
    inadimplentes: 0,
    canceladas: 0,
}

export type ClubeBeneficiosContextType = {
    dados: ClubeBeneficiosModel
    dispatch: React.Dispatch<ClubeBeneficiosActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
    assinantes: AssinanteClube[]
    totais: TotaisAssinantesClube
    /** mensalidades pagas no mês corrente (null = backend não informou) */
    resumoFinanceiro: ResumoFinanceiroClube | null
    filtroStatus: StatusAssinaturaClube | ""
    /** plano (clubeId) filtrado na aba Assinantes; "" = todos */
    filtroClubeId: number | ""
    carregandoAssinantes: boolean
    erroAssinantes: string | null
    /** Sem argumentos, mantém os filtros atuais. */
    carregarAssinantes: (status?: StatusAssinaturaClube | "", clubeId?: number | "") => Promise<void>
    cancelarAssinatura: (idAssinatura: number, motivo: string) => Promise<void>
    /** Mensalidades pagas de uma assinatura (mais recente primeiro). Lança Error em falha. */
    carregarMensalidades: (idAssinatura: number) => Promise<MensalidadeClube[]>
}

export const ClubeBeneficiosContext = React.createContext<ClubeBeneficiosContextType>({
    dados: ClubeBeneficiosInicial,
    dispatch: () => undefined,
    salvar: async () => undefined,
    erroCarregamento: null,
    assinantes: [],
    totais: TotaisAssinantesInicial,
    resumoFinanceiro: null,
    filtroStatus: "",
    filtroClubeId: "",
    carregandoAssinantes: false,
    erroAssinantes: null,
    carregarAssinantes: async () => undefined,
    cancelarAssinatura: async () => undefined,
    carregarMensalidades: async () => [],
})
